var _path, _path2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgRedo = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2466 12.7067H5.91329C3.79996 12.7067 2.07996 10.9867 2.07996 8.87337C2.07996 6.76004 3.79996 5.04004 5.91329 5.04004H13.2466C13.52 5.04004 13.7466 5.26671 13.7466 5.54004C13.7466 5.81337 13.52 6.04004 13.2466 6.04004H5.91329C4.35329 6.04004 3.07996 7.31337 3.07996 8.87337C3.07996 10.4334 4.35329 11.7067 5.91329 11.7067H11.2466C11.52 11.7067 11.7466 11.9334 11.7466 12.2067C11.7466 12.48 11.5266 12.7067 11.2466 12.7067Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7133 7.70671C11.5866 7.70671 11.46 7.66004 11.36 7.56004C11.1666 7.36671 11.1666 7.04671 11.36 6.85338L12.7133 5.50004L11.36 4.14671C11.1666 3.95338 11.1666 3.63338 11.36 3.44004C11.5533 3.24671 11.8733 3.24671 12.0666 3.44004L13.7733 5.14671C13.9666 5.34004 13.9666 5.66004 13.7733 5.85338L12.0666 7.56004C11.9666 7.66004 11.84 7.70671 11.7133 7.70671Z",
    fill: "#757575"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRedo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/redo.cf042bab.svg";
export { ForwardRef as ReactComponent };